export function locationProxy(window) {
  return function proxy() { return window.location.href; };
}

export default locationProxy(window);
